import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { Observable } from 'rxjs/internal/Observable';
import { ErrorHelper } from '../../common/ErrorHelper';
import { FileElement } from '../../common/file-manager/model/file-element';
import { FileBrowserService } from '../../services/file-browser.service';

@Component({
  selector: 'app-file-browser',
  templateUrl: './file-browser.component.html',
  styleUrls: ['./file-browser.component.css']
})
export class FileBrowserComponent implements OnInit {

  public fileElements: Observable<FileElement[]>;

  constructor(public fileService: FileBrowserService,
              public notifierService: NotifierService) {}

  currentRoot: FileElement;
  currentPath: string;
  currentParent: string;
  canNavigateUp = false;
  isLoading = false;

  ngOnInit(): void {
    this.loadFileElementsAsync('');
  }

  async loadFileElementsAsync(path: string): Promise<any> {
    this.isLoading = true;
    try {
      await this.loadFileElements(path);
    } catch (error) {
      console.log(error);
    } finally {
      this.updateFileElementQuery();
      this.isLoading = false;
    }
  }

  loadFileElements(path: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.fileService.getFileElements(path).toPromise().then(
        (data) => {
          data.forEach( element => this.fileService.add(element));
          console.log('Fetched the file elements for ' + path);
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load file elements', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }

  removeElement(element: FileElement): void {
    this.fileService.deleteFileElement(this.currentPath + element.name).toPromise().
      then(isDeleted => {
        if (isDeleted) {
          this.notifierService.notify('error', element.name + ' deleted.');
        } else {
          this.notifierService.notify('error', element.name + ' could not be deleted.');
        }
      });
    this.fileService.delete(element.id);
    this.updateFileElementQuery();
  }

  navigateToFolder(element: FileElement): void {
    this.currentRoot = element;
    if (this.currentParent === element.parent){
      this.currentPath = this.popFromPath(this.currentPath);
    }
    this.currentPath = this.pushToPath(this.currentPath, element.name);
    this.currentParent = element.parent;
    this.loadFileElementsAsync(this.currentPath);
    this.canNavigateUp = true;
  }

  navigateUp(): void {
    if (this.currentRoot && this.currentRoot.parent === 'root') {
      this.currentRoot = null;
      this.currentParent = 'root';
      this.canNavigateUp = false;
      this.updateFileElementQuery();
    } else {
      this.currentRoot = this.fileService.get(this.currentRoot.parent);
      this.currentParent = this.currentRoot.parent;
      this.updateFileElementQuery();
    }
    this.currentPath = this.popFromPath(this.currentPath);
  }

  updateFileElementQuery(): void {
    this.fileElements = this.fileService.queryInFolder(this.currentRoot ? this.currentRoot.id : 'root');
  }

  pushToPath(path: string, folderName: string): string {
    let p = path ? path : '';
    if(!(p.includes(folderName))){
      p += `${folderName}/`;
    }
    return p;
  }

  popFromPath(path: string): string {
    let p = path ? path : '';
    let split = p.split('/');
    split.splice(split.length - 2, 1);
    p = split.join('/');
    return p;
  }
}
